import React from "react";

const Benefits = () => {
  return (
    <div data-aos="zoom-in-up" data-aos-duration="1000" className="bg-guid-bg bg-cover w-11/12 mx-auto rounded-3xl my-4" id="How">
      <div className="text-gray-50 py-28 md:py-96 ml-16">
        <h5 className="text-xl md:text-2xl font-bold">A Guided Tour of</h5>
        <h2 className="text-3xl md:text-5xl font-bold my-3">iPhone 14 &</h2>
        <h2 className="text-3xl md:text-5xl font-bold">iPhone 14 Pro</h2>
      </div>
    </div>
  );
};

export default Benefits;
